import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("a", {
    href: $props.link,
    target: $props.target,
    class: _normalizeClass(["button", [
      `button--${$props.size}`,
      `button--${$props.color}`,
      $props.isDisabled && 'button--disabled',
    ]])
  }, [
    ($props.icon && $props.icon.length)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "button__icon",
          name: $props.icon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 10, _hoisted_1))
}